<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="750">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          Config SPKPR
        </v-card-title>
        <v-card-text>
          <v-form class="pt-5 pb-0">
            <quill-editor 
              ref="myTextEditor"
              class="quills"
              :options="option"
              v-model="form.content">
            </quill-editor>
          </v-form>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-container class="py-0"> -->
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card flat min-height="800">
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
              <v-row>
                <v-col cols="8" class="py-0">
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                    :color="style.primary"
                    elevation="3"
                    class="text-capitalize white--text"
                    @click="reset()">
                    <v-icon small class="mr-1">mdi-pencil-minus-outline</v-icon>
                    Config SPKPR
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"/>
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 650px;">
              <v-skeleton-loader
                v-for="i in process.run ? 5 : 1"
                :key="i"
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="article">
                <v-card flat>
                  <v-card-text 
                    v-if="!process.run && Object.keys(detail).length > 0"
                    v-html="detail.ref_surat_pesanan_pembelian_content">
                  </v-card-text>
                </v-card>
              </v-skeleton-loader>
              <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 550px;" v-if="!process.run && Object.keys(detail).length < 1">
                <v-img 
                  class="my-12"
                  contain
                  width="200"
                  height="200"
                  :src="require('../../assets/404/404.svg')">
                </v-img>
              </div>
              <v-divider/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        dialog: {
          form: false,
          delete: false
        },
        detail: {},
        form: {
          id: 0,
          content: ''
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch() {
        this.process.run = true

        await get(`auth/company/surat-pesanan-pembelian/detail-by-company`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.detail = res.data
          }
        })
      },
      reset() {
        this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          id: Object.keys(this.detail).length > 0 ? this.detail.ref_surat_pesanan_pembelian_id : 0,
          content: Object.keys(this.detail).length > 0 ? this.detail.ref_surat_pesanan_pembelian_content : ''
        }

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/surat-pesanan-pembelian/create`, {
          data: this.form
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.reset()
            this.fetch()
          } else {
            console.log('gagal', res)
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>

<style>
.quill-editor.quills .ql-editor {
	min-height: 500px !important;
}
</style>